export default {
  template: null,
}
